import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DxChartModule } from 'devextreme-angular';
import { AppService } from '../../../services/app.service';
import { DashboardService } from '../../../services/dashboard.service';
import { OrderService } from "../../../services/order.service";
import { MasterService } from "../../../services/master.service";
import { Order, OrderData } from '../../../models/dashboard.model'

@Component({
  selector: 'app-order-chart',
  templateUrl: './order-chart.component.html',
  styleUrls: ['./order-chart.component.scss']
})


export class OrderChartComponent implements OnInit {
	@ViewChild('inpDistributor') inpDistributor;
	@ViewChild('inpOrderDateColumns') inpOrderDateColumns;

	@Input('translations') translations: any;

	ordersData: any[];
	orders: any[];
	months: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	years: any[] = [];

	distributorList: any = [];
    distributorId: Number;    

    orderDateColumnList: any = [];
    orderDateColumnId: Number;    

    graphTitle: string = "";

	constructor(public appService: AppService, public dashService: DashboardService, private orderService: OrderService, public masterService : MasterService) { 
		this.getDistributors();
	}

	ngOnInit() {
		
	}

	updateGraph(){
		this.appService.showLoading();
		this.graphTitle = this.orderDateColumnId == 601 ? this.translations.lblGraphOrdersReceived : this.translations.lblGraphOrdersDelivered;
		this.dashService.orders(this.distributorId, this.orderDateColumnId).subscribe(
	      res => this.getOrdersSuccess(res),
	      error => this.apiFaillure(error)
	    );
	}

	getOrdersSuccess(res){
		this.appService.hideLoading();
		if (res.Status) {
	      if (res.Data != 'null' && JSON.parse(res.Data).length > 0){
	          this.ordersData = JSON.parse(res.Data);
	          this.months = Object.keys(this.ordersData[0]);
	          this.months.shift();
	          this.processOrders();
	      }
	      else
	      {
	      	  this.setNoOrdersData();
	          this.months = Object.keys(this.ordersData[0]);
	          this.months.shift();
	          this.processOrders();
	      } 
	    }
	}

	apiFaillure(error): void {
	    this.appService.hideLoading();
	    this.appService.showDialogue("Error", error.Message);
	}

	processOrders(){
		var availableYears = this.ordersData.map(a => a.Year);
		this.years = [];
		if(availableYears.length == 1 && availableYears[0] == (new Date()).getFullYear()){
			var lastYr = (new Date()).getFullYear() - 1;
			this.years.push(lastYr);
			this.years.push(availableYears[0]);
			this.ordersData.unshift({Year: lastYr, Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0});
		}
		else if(availableYears.length == 1 && availableYears[0] == ((new Date()).getFullYear() - 1)){
			this.years.push(availableYears[0])
			var curYr = (new Date()).getFullYear();
			this.years.push(curYr);
		}else{
			this.years = this.ordersData.map(a => a.Year);
		}

		this.orders = [];
		for(let i = 0; i < this.months.length; i++){
			var order = new Order();
			order.Month = this.months[i];
			order.LastYear = this.ordersData[0][this.months[i]];
			order.CurrentYear = this.ordersData.length == 2 ? this.ordersData[1][this.months[i]] : 0;
			this.orders.push(order);
		}
	}

	setNoOrdersData(){
		this.ordersData = [];
		this.ordersData.push({Year: 0, Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0});
		this.ordersData.push({Year: 0, Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0, Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0});
		this.ordersData[0].Year = (new Date()).getFullYear() - 1;
		this.ordersData[1].Year = (new Date()).getFullYear();
	}

	onPointClick(e) {
	    e.target.select();
	}

	getDistributors(){
	  this.orderService.getDistributors().subscribe(
	    res => this.distributorSuccess(res),
	    error => this.apiFaillure(error)
	  );
	}

	distributorSuccess(res){
		if (res.Data != null) {
		  this.distributorList = JSON.parse(res.Data).Table;
		  this.distributorId = this.distributorList.length == 1 ? this.distributorList[0].Id : 0;
		  this.getOrderDateColumns();
		} else {
		  this.apiFaillure(res.Message);
		}
	}

	getOrderDateColumns(){
	  this.masterService.selectSysData("OrderDateColumn","").subscribe(
	    res => this.orderDateColumnsSuccess(res),
	    error => this.apiFaillure(error)
	  );
	}

	orderDateColumnsSuccess(res){
		if (res.Data != null) {
		  this.orderDateColumnList = JSON.parse(res.Data);
		  this.orderDateColumnId = this.orderDateColumnList[0].Id;
		  this.updateGraph();
		} else {
		  this.apiFaillure(res.Message);
		}
	}
	
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/dashboard/order-chart/order-chart.component.ts